import React, { useEffect, useState } from 'react';
import { Card } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useAuthContext } from 'src/auth/hooks';
import { fetchInterviewResult } from 'src/services/interview.service';
import { getOrganizationId } from 'src/services/user.service';
import { setError, setLoading, setSuccess } from 'src/store/modalSlice';
import EmptyContent from 'src/components/empty-content';
import InterviewResult from 'src/sections/interview/interview-result';
import CandidateCaptures from 'src/sections/interview/interview-result/candidate-captures';
import ScreenRecordings from 'src/sections/interview/interview-result/screen-recordings';

const InterviewDetails = ({ jobId, candidateDetails }) => {
  // context
  const { user } = useAuthContext();
  const dispatch = useDispatch();

  // states
  const [score, setScore] = useState('NA');
  const [totalScore, setTotalScore] = useState(0);
  const [interview, setInterview] = useState(null);
  const [candidateCaptures, setCandidateCaptures] = useState([]);

  // variables
  const organization_id = getOrganizationId(user);

  // effects
  useEffect(() => {
    if (candidateDetails.interview_details) {
      dispatch(setLoading(true));
      fetchInterviewResult(
        jobId,
        candidateDetails.interview_details.interview_id,
      )
        .then(data => {
          let totaldum = 0;
          data.body.solutions.forEach(sol => {
            totaldum += sol.score;
          });
          setTotalScore(
            parseInt((totaldum / (data.body.solutions.length * 10)) * 100, 10),
          );
          dispatch(setLoading(false));
          if (data.success === true) {
            setInterview(data.body);
            dispatch(setSuccess(data.message));
            if (!data.body.total_score) {
              let tmpScore = 0;
              data.body.solutions.forEach(s => {
                tmpScore = +s.score;
              });
              setScore(parseInt(tmpScore, 10));
            } else {
              setScore(parseInt(data.body.total_score, 10));
            }
          } else {
            dispatch(setError(data.message));
          }
        })
        .catch(err => {
          dispatch(setLoading(false));
          dispatch(setError(err.message));
        });
    }
  }, [
    organization_id,
    dispatch,
    interview,
    jobId,
    candidateDetails.interview_details,
  ]);

  useEffect(() => {
    if (interview) {
      interview.solutions.forEach(
        solution =>
          solution.candidate_captures &&
          setCandidateCaptures(prevProps => {
            const currentCaptures = [
              ...prevProps,
              ...solution.candidate_captures,
            ];
            if (currentCaptures.length > 4) return currentCaptures.slice(0, 4);
            return currentCaptures;
          }),
      );
    }
  }, [interview]);

  return interview ? (
    <>
      <InterviewResult score={score} interview={interview} />
      <CandidateCaptures candidateCaptures={candidateCaptures} />
      <ScreenRecordings screenRecordings={interview.screen_recordings} />
    </>
  ) : (
    <Card sx={{ p: 3 }}>
      <EmptyContent
        filled
        title="No Interview Data"
        sx={{
          py: 10,
        }}
      />
    </Card>
  );
};

InterviewDetails.propTypes = {
  jobId: PropTypes.string,
  candidateDetails: PropTypes.object,
};

export default InterviewDetails;
